module.exports = __webpack_public_path__ + "img/09.abd5d929.jpg";